import React from 'react';
import { Row } from 'antd';
import { Image, MenuContainer, MenuItem, MenuText } from '../../../../shared.style';
import FactoryListIcon from '../../../../assets/icons/icon_factory_list.png';

const MenuAccountFactory = ({ history }) => {
  return (
    <MenuContainer>
      <Row justify="center">
        <MenuItem onClick={() => history.push(`/account/factory`)}>
          <Image src={FactoryListIcon} alt="profile" />
        </MenuItem>
      </Row>
      <Row justify="center">
        <MenuText>ประกาศของคุณ</MenuText>
      </Row>
    </MenuContainer>
  );
};

export default MenuAccountFactory;



// WEBPACK FOOTER //
// ./src/pages/Account/components/MenuAccountFactory/index.js